/**
 * Island - Base floating island component for the Ramp View UI
 *
 * All UI controls on the Ramp View float as translucent "islands" over the
 * full-screen 3D viewport. This component provides the shared glass-blur
 * styling, rounded corners, and auto-minimize animation.
 *
 * Design: backdrop-filter: blur(20px), semi-transparent background,
 * subtle border and shadow. Islands minimize (fade + scale) during
 * aircraft drag/rotate/placement to maximize workspace.
 */

import { cn } from '@/lib/utils'

interface IslandProps {
  children: React.ReactNode
  className?: string
  /** When true, island fades out and becomes non-interactive */
  minimized?: boolean
}

export function Island({ children, className, minimized = false }: IslandProps) {
  return (
    <div
      className={cn(
        // Glass morphism base
        'bg-background/92 backdrop-blur-[20px]',
        'rounded-xl',
        'shadow-lg',
        'border border-border/50',
        // Minimize transition
        'transition-all duration-200 ease-out',
        minimized && 'opacity-0 scale-95 pointer-events-none',
        className
      )}
    >
      {children}
    </div>
  )
}
